import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { ItemContentComponent } from '../../item-content/item-content.component';
@Component({
    selector: 'app-transfer-item-v3',
    templateUrl: './transfer-item-v3.component.html',
    styleUrl: './transfer-item-v3.component.scss',
    imports: [ItemContentComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransferItemComponentV3 implements SheetItemComponentBase {

	@Input() row!: Row;
    @Input() startLabel!: string;
    @Input() endLabel!: string;
	
	constructor() {
	}
}